import { render, staticRenderFns } from "./PracticeImport.vue?vue&type=template&id=a343bc7c"
import script from "./PracticeImport.vue?vue&type=script&lang=js"
export * from "./PracticeImport.vue?vue&type=script&lang=js"
import style0 from "./PracticeImport.vue?vue&type=style&index=0&id=a343bc7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports